export const dashboardMutations = {
  setDashboardTab(state, tabName) {
    switch (tabName) {
      case 'Service':
        state.currentTab = 'Service';
        break;
      case 'AppDB':
        state.currentTab = 'AppDB';
        break;

      case 'Endpoint':
        state.currentTab = 'Endpoint';

        break;
      case 'Instance':
        state.currentTab = 'Instance';

        break;
      case 'Database':
        state.currentTab = 'AppDB';
        break;
      case 'Infrastructure':
        state.currentTab = 'Infrastructure';
        break;
      default:
        state.currentTab = 'Service';
        break;
    }
  },

  setMetaData(state, [data, total, entity]) {
    switch (entity) {
      case 'Endpoint':
        state.endpointsMeta = data;
        state.endpointsTotal = total;
        break;
      case 'ServiceInstance':
        state.instancesMeta = data;
        state.instancesTotal = total;
        break;
    }
  },

  setDatabaseQuery(state, data) {
    state.databaseStatements = data;
  },

  setDatabaseQueryTotal(state, data) {
    state.databaseStatementTotal = data;
  },
  setApdexEnabled(state, data) {
    state.apdexEnabled = data;
  },
  setActiveInstanceCount(state, data) {
    state.activeInstanceCount = data;
  },
};
